import { getFirestore, collection, doc, getDoc, getDocs, updateDoc, addDoc, deleteDoc, setDoc } from "firebase/firestore";
import { getStorage, ref, uploadString, getDownloadURL, deleteObject } from "firebase/storage";
import Vue from "vue";
import Axios from "axios";
import VueAxios from "vue-axios";
import { requestEndPoint } from '@/store/Api'
import { v4 as uuidv4 } from "uuid";

Vue.use(VueAxios, Axios);

const db = getFirestore();

const storage = getStorage()
const storageImages = ref(storage, "backgroundAppImages/");
const splashStorage = ref(storage, 'customLoadingScreen');
const headerStorage = ref(storage, 'customHomeHeaderImages');

Vue.use(VueAxios, Axios);

export default {
    state: {
        backgroundAppImagesList: [],
        loadingStatusBackgroundAppImage: 0,
        featuredSplashes: [],
        splashProgress: 0,
        headerProgress: 0,
        latestWorkouts: []
    },
    mutations: {
        SET_VALUE_LOADING_STATUS_BACKGROUND_APP_IMAGE(state, progress) {
            state.loadingStatusBackgroundAppImage = progress
        },
        SET_BACKGROUND_APP_IMAGES_LIST(state, backgroundAppImagesList) {
            state.backgroundAppImagesList = backgroundAppImagesList
        },
        SET_FEATURED_SPLASH(state, newValue) {
            state.featuredSplashes = newValue;
        },
        SET_SPLASH_UPLOAD_PROGRESS(state, progress) {
            state.splashProgress = progress;
        },
        SET_HEADER_UPLOAD_PROGRESS(state, progress) {
            state.headerProgress = progress;
        },
        SET_LATEST_WORKOUTS(state, workouts) {
            state.latestWorkouts = workouts;
        }
    },
    actions: {
        GetBackgroundAppImagesList({ commit }) {
            return new Promise((resolve, reject) => {
                getDocs(collection(db, "backgroundAppImagesList")).then((querySnapshot) => {
                        var backgroundAppImagesList = [];
                        querySnapshot.forEach((doc) => {
                            let backgroundAppImage = doc.data();
                            backgroundAppImage.id = doc.id;
                            backgroundAppImagesList.push(backgroundAppImage);
                        });
                        commit("SET_BACKGROUND_APP_IMAGES_LIST", backgroundAppImagesList);
                        resolve(backgroundAppImagesList);
                    }).catch((err) => {
                        reject(err)
                    })
            });
        },
        UploadBackgroundAppImage({ commit }, backgroundAppImage) {
            return new Promise(async (resolve, reject) => {
                try {
                    let random = uuidv4();
                    let storageRef = ref(storage, `backgroundAppImages/${random}`);
                    
                    // Upload the string
                    await uploadString(storageRef, backgroundAppImage.image.img, "data_url");
                    
                    // Get the download URL
                    const downloadURL = await getDownloadURL(storageRef);
                    resolve({ link: downloadURL, ref: random });
                } catch (error) {
                    console.log('error', error);
                    reject(error);
                }
            });
        },
        CreateBackgroundAppImage({ }, backgroundAppImage) {
            return new Promise(async (resolve, reject) => {
                delete backgroundAppImage.image.img
                const ref = doc(collection(db, "backgroundAppImagesList"));
                const newBackgroundAppImage = await getDoc(ref);
                backgroundAppImage.id = newBackgroundAppImage.id;
                backgroundAppImage.createdAt = new Date()
                backgroundAppImage.updatedAt = new Date()
                await setDoc(ref, backgroundAppImage)
                    .then(async (res) => {
                        resolve(newBackgroundAppImage.id);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            })
        },
        CreateCustomSplash({ }, data) {
            return new Promise(async (resolve, reject) => {
                const result = await addDoc(collection(db, 'customLoadingScreen'), data);
                resolve(result.id);
            })
        },
        UpdateBackgroundAppImage({ }, backgroundAppImage) {
            return new Promise(async (resolve, reject) => {
                if (backgroundAppImage.image.img) {
                    delete backgroundAppImage.image.img
                }
                if (backgroundAppImage.createdAt) {
                    delete backgroundAppImage.createdAt
                }
                backgroundAppImage.updatedAt = new Date()
                await updateDoc(doc(db, "backgroundAppImagesList", backgroundAppImage.id), backgroundAppImage)
                    .then((res) => {
                        resolve(backgroundAppImage.id);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },
        async DeleteBackgroundAppImage({ }, backgroundAppImage) {
            return new Promise(async (resolve, reject) => {
                let storageRefImage = ref(storage, `backgroundAppImages/${backgroundAppImage.image.ref}`);
                await deleteObject(storageRefImage)
                    .then(async () => {
                        await deleteDoc(doc(db, "backgroundAppImagesList", backgroundAppImage.id))
                            .then((res) => {
                                resolve(backgroundAppImage.id);
                            })
                            .catch((err) => {
                                reject(err);
                            });
                    }).catch((errorImg) => {
                        console.log('errorImg deleting storage', errorImg);
                        // Uh-oh, an error occurred!
                    });

            });
        },
        async DeleteImageByRef({ }, data) {
            const ref = data.ref;
            const type = data.type;
            return new Promise(async (resolve, reject) => {
                try {
                    if (type === 'splash') {
                        await deleteObject(ref(storage, ref));
                    } else {
                        await deleteObject(ref(storage, ref));
                    }
                    resolve('done');
                } catch (error) {
                    reject(error);
                }
            });
        },
        async DeleteSplash({ }, splash) {
            return new Promise(async (resolve, reject) => {
                try {
                    try {
                        await deleteObject(ref(storage, splash.splashRef));
                    } catch (error) {
                        console.log(error);
                    }

                    try {
                        await deleteObject(ref(storage, splash.headerRef));
                    } catch (error) {
                        console.log(error);
                    }

                    await deleteDoc(doc(db, 'customLoadingScreen', splash.id));
                    resolve(splash.id);
                } catch (error) {
                    reject(error);
                }
            });
        },
        async GetFeaturedSplashScreens({ commit }) {
            try {
                const result = await getDocs(collection(db, "customLoadingScreen"));
                const resultData = result.docs.map(r => ({
                    ...r.data(),
                    id: r.id,
                    startDate: r.data().startDate.toDate(),
                    endDate: r.data().endDate.toDate()
                }));
                commit("SET_FEATURED_SPLASH", resultData);
            } catch (error) {
                console.error(error);
            }
        },
        async UploadSplashImage({ commit }, image) {
            return new Promise(async (resolve, reject) => {
                try {
                    let random = uuidv4();
                    let storageRef = ref(storage, `customLoadingScreen/${random}`);
                    
                    // Upload the string
                    await uploadString(storageRef, image.img, "data_url");
                    
                    // Get the download URL
                    const downloadURL = await getDownloadURL(storageRef);
                    resolve({ link: downloadURL, ref: random });
                } catch (error) {
                    console.log('error', error);
                    reject(error);
                }
            });
        },
        async UploadHeaderImage({ commit }, image) {
            return new Promise(async (resolve, reject) => {
                try {
                    let random = uuidv4();
                    let storageRef = ref(storage, `customHomeHeaderImages/${random}`);
                    
                    // Upload the string
                    await uploadString(storageRef, image.img, "data_url");
                    
                    // Get the download URL
                    const downloadURL = await getDownloadURL(storageRef);
                    resolve({ link: downloadURL, ref: random });
                } catch (error) {
                    console.log('error', error);
                    reject(error);
                }
            });
        },
        UpdateSplash({ }, splash) {
            return new Promise(async (resolve, reject) => {
                try {
                    await updateDoc(doc(db, "customLoadingScreen", splash.id), splash);
                    resolve(splash.id);
                } catch (error) {
                    reject(error);
                }
            });
        },
        async GetLatestWorkouts({ commit }) {
            return new Promise(async (resolve, reject) => {
                try {
                    const latestWorkoutsRef = doc(db, "appConfiguration", "latestWorkouts");
                    const latestWorkoutsDoc = await getDoc(latestWorkoutsRef);
                    
                    if (latestWorkoutsDoc.exists()) {
                        const data = latestWorkoutsDoc.data();
                        commit("SET_LATEST_WORKOUTS", data.workouts || []);
                        resolve({
                            workouts: data.workouts || [],
                            customOrderEnabled: data.customOrderEnabled || false
                        });
                    } else {
                        commit("SET_LATEST_WORKOUTS", []);
                        resolve({
                            workouts: [],
                            customOrderEnabled: false
                        });
                    }
                } catch (error) {
                    console.error('Error getting latest workouts:', error);
                    reject(error);
                }
            });
        },
        async UpdateLatestWorkouts({ commit }, workouts) {
            return new Promise(async (resolve, reject) => {
                try {
                    const latestWorkoutsRef = doc(db, "appConfiguration", "latestWorkouts");
                    await setDoc(latestWorkoutsRef, {
                        workouts: workouts,
                        updatedAt: new Date()
                    }, { merge: true });
                    commit("SET_LATEST_WORKOUTS", workouts);
                    resolve(workouts);
                } catch (error) {
                    console.error('Error updating latest workouts:', error);
                    reject(error);
                }
            });
        },
    },
    getters: {
        getAppBackgrounds(state) {
            return state.backgroundAppImagesList;
        },
        getLoadingStatusBackgroundAppImage(state) {
            return state.loadingStatusBackgroundAppImage;
        },
        getFeaturedSplashes(state) {
            return state.featuredSplashes;
        },
        getLoadingSplashImages(state) {
            const value = (state.splashProgress + state.headerProgress) / 2;
            console.log(value);
            return value;
        },
        getLatestWorkouts(state) {
            return state.latestWorkouts;
        }
    }
}